export var CreditLoadingPageType;
(function (CreditLoadingPageType) {
    CreditLoadingPageType["CIBIL"] = "CIBIL";
    CreditLoadingPageType["CHECK_ELIGIBILITY"] = "CHECK_ELIGIBILITY";
    CreditLoadingPageType["DEFAULT"] = "DEFAULT";
})(CreditLoadingPageType || (CreditLoadingPageType = {}));
